import React from 'react';
interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  centered?: boolean;
  className?: string;
}
export const SectionHeading: React.FC<SectionHeadingProps> = ({
  title,
  subtitle,
  centered = false,
  className = ''
}) => {
  return <div className={`mb-12 ${centered ? 'text-center' : ''} ${className}`} data-id="element-724">
      <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-white mb-4" data-id="element-725">
        {title}
      </h2>
      {subtitle && <p className="text-xl text-gray-300 max-w-3xl mx-auto" data-id="element-726">{subtitle}</p>}
    </div>;
};